<template>
  <v-container fluid class="background-white fill-height">
    <v-row class="no-gutters flex-wrap flex-column fill-height">
      <v-col cols="auto">
        <campaign-image :imageUrl="campaign.logo" />
        <v-sheet>
          <div class="pa-4 px-8 text-center text-body-2">
            {{ survey.thankyou_message }}
          </div>
        </v-sheet>
      </v-col>
      <v-col cols="auto" class="grow gray mb-8">
        <v-card
          flat
          unelevated
          tile
          fill-height
          align="center"
          justify="center"
        >
          <a
            v-for="banner in survey.banners"
            :key="banner.id"
            target="_blank"
            :href="banner.url || '#'"
          >
            <v-img
              fill
              :src="
                banner.banner ||
                'https://via.placeholder.com/640x200/DFDFDF?Text=Npo+image'
              "
              class="mx-auto pb-2"
            ></v-img>
          </a>
          <v-card-text v-if="survey.coupon_uploaded">
            <a download="coupon" target="_blank" :href="couponUrl || '#'">
              {{ survey.coupon_label || "Scarica il tuo coupon" }}
            </a>

            <!-- <a @click.prevent="openCoupon">
              {{ survey.coupon_label || "Scarica il tuo coupon" }}
            </a> -->
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import campaignImage from '@/components/qrcode-vote-components/BaseHeaderImage'

export default {
  props: {
    bodyProps: {
      type: Object
    }
  },
  components: {
    campaignImage
  },
  computed: {
    couponUrl () {
      return `${process.env.VUE_APP_BASE_URL}/surveys/${this.survey.id}/download/coupon`
    },
    rulesUrl () {
      return `${process.env.VUE_APP_BASE_URL}/campaigns/${this.campaign.campaign}/download/rules`
    }
  },
  data () {
    return {
      statement: '',
      message: '',
      qrcodeSuccess: false,
      qrcodeError: false,
      qrcodeLeadCreated: false,
      campaign: null
    }
  },
  created () {
    if (JSON.parse(sessionStorage.getItem('campaign'))) {
      const campaign = JSON.parse(sessionStorage.getItem('campaign'))
      this.campaign = campaign
    }

    if (JSON.parse(sessionStorage.getItem('survey'))) {
      const survey = JSON.parse(sessionStorage.getItem('survey'))
      this.survey = survey
    }
  },

  methods: {
    openCoupon () {
      this.pdfUrl = this.survey.coupon
      let byteCharacters = atob(this.pdfUrl)
      let byteNumbers = new Array(byteCharacters.length)
      for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      let byteArray = new Uint8Array(byteNumbers)
      let file = new Blob([byteArray], { type: 'application/pdf;base64' })
      this.pdfUrl = (window.URL || window.webkitURL).createObjectURL(file)

      window.open(this.pdfUrl, '_blank')
    },
    revealMessage (status) {
      if (this.bodyProps.status === 'success') {
        this.qrcodeSuccess = true
        this.statement = 'Successo'
        this.message =
          'Abbiamo ricevuto il tuo voto, grazie per il tuo supporto.'
      }
      if (this.bodyProps.status === 'error') {
        this.qrcodeError = true
        this.statement = 'Qualcosa è andato storto'
        this.message = 'Sembra che questo codice sia già stato utilizzato.'
      }
      if (this.bodyProps.status === 'leadCreated') {
        this.qrcodeLeadCreated = true
        this.statement = 'Successo'
        this.message =
          'Controlla la tua casella di posta, riceverai una mail per confermare la tua email.'
      }
    }
  }
}
</script>
<style scoped>
.container {
  background-color: #fff;
  padding: 0;
}
</style>
